import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsBetRecordSummaryQuery implements ICommand
{

	public FromDate : string = "";
	public ToDate : string = "";
	public RecentRound : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.FromDate = ba.readString();
		this.ToDate = ba.readString();
		this.RecentRound = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeString(this.FromDate);
		ba.writeString(this.ToDate);
		ba.writeUint32(this.RecentRound);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsBetRecordSummaryQuery();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'FromDate(S)='+this.FromDate+' ';
		str += 'ToDate(S)='+this.ToDate+' ';
		str += 'RecentRound(D)='+this.RecentRound+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55106;
	}

	public getCmdName() : string
	{
		return 'PsBetRecordSummaryQuery';
	}

}
